import { lazy } from "react";

const ContactListPage = lazy(() => import("./main"));
const UpdateContactPage = lazy(() => import("./update"));

export { ContactListPage, UpdateContactPage };
